import { Component, HostListener } from '@angular/core';
import { StateHeaderComponent } from "../../components/state-header/state-header.component";
import { StateFooterComponent } from "../../components/state-footer/state-footer.component";
import { AccessibilityHeaderComponent } from "../../../common/accessibility-header/accessibility-header.component";
import { CommonModule } from '@angular/common';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { IasLoaderComponent } from "../../../common/ias-loader/ias-loader.component";
import { ActivatedRoute, Router } from '@angular/router';
declare var bootstrap: any;
@Component({
  selector: 'app-state-landing-page',
  standalone: true,
  imports: [StateHeaderComponent, StateFooterComponent, AccessibilityHeaderComponent, CommonModule, SlickCarouselModule, IasLoaderComponent],
  templateUrl: './state-landing-page.component.html',
  styleUrl: './state-landing-page.component.scss'
})
export class StateLandingPageComponent {
  constructor(private http: HttpClient, private router: Router,private route: ActivatedRoute) { }
  pageData: any;
  loading: boolean = false;
  loading1: boolean = false;
  loading2: boolean = false;
  officeBearers: any[] = [];
  groupedBearers: any[] = [];
  galleryImages: any[] = [];
  toastMessage = '';
  toastType: string = 'primary';
  dynamicImageUrl = 'assets/images/state-banner.png';
id: string | null = null;
  ngOnInit() {
     this.route.queryParamMap.subscribe(params => {
      this.id = params.get('id');
      if (this.id) {
        this.loadData(this.id);
        this.loadNews(this.id); 
        this.loadGallery(this.id);
      }
      else{
        this.showToast('Invalid State Association ID', 'danger');
        this.router.navigateByUrl('/homepage');
      }
    });
  }
  loadData(id: string) {
    this.loading = true;
    this.http.get(`${environment.apiUrl}/state-associations/${id}`).subscribe(
      (data: any) => {
        this.loading = false;
        // console.log('Data loaded successfully:', data);
        this.pageData = data.data?.data?.cadre;
        console.log(this.pageData);
        this.officeBearers = (this.pageData?.officeBearer || []).filter(
          (item: any) => item.isActive === true
        );

        // this.allItems = (this.pageData?.latestNewsEvents || []).filter(
        //   (item: any) => item.isActive === true
        // );
        // this.galleryImages = (this.pageData?.gallery || []).filter(
        //   (item: any) => item.isActive === true
        // );

        // console.log(this.officeBearers);
        this.groupItemsByScreenWidth();
        this.filterItems();

      },
      (error) => {
        this.loading = false;
        this.showToast('Something Went Wrong', 'danger');
        this.router.navigateByUrl('/homepage');
        console.error('Error loading data:', error);
      }
    );
  }
  loadNews(id: string) {
    this.loading1 = true;
    this.http.get(`${environment.apiUrl}/state-associations/${id}/news`).subscribe(
      (data: any) => {
        this.loading1 = false;
        // console.log('News loaded successfully:', data);

        this.allItems = (data.data?.data?.latestNewsEvents || []).filter(
          (item: any) => item.isActive === true
        );
        this.filterItems();

      },
      (error) => {
        this.loading1 = false;
        this.showToast('New Fatch Failed', 'danger');
        console.error('Error loading data:', error);
      }
    );
  }
  loadGallery(id: string) {
    this.loading2 = true;
    this.http.get(`${environment.apiUrl}/state-associations/${id}/gallery`).subscribe(
      (data: any) => {
        this.loading2 = false;
        // console.log('gallery successfully:', data);

       this.galleryImages = (data.data?.data?.gallery || []).filter(
          (item: any) => item.isActive === true
         );

      },
      (error) => {
        this.loading2 = false;
        this.showToast('Gallery Fatch Failed', 'danger');
        console.error('Error loading data:', error);
      }
    );
  }

  @HostListener('window:resize')
  onResize() {
    this.groupItemsByScreenWidth();
  }

  private groupItemsByScreenWidth() {
    const isMobile = window.innerWidth < 992; // Bootstrap lg breakpoint
    const groupSize = isMobile ? 2 : 4;
    this.groupedBearers = [];

    for (let i = 0; i < this.officeBearers.length; i += groupSize) {
      this.groupedBearers.push(this.officeBearers.slice(i, i + groupSize));
    }
  }
  activeTab: 'news' | 'event' = 'event';

  allItems: any[] = [];

  filteredItems: any;

  // setTab(tab: 'news' | 'event') {
  //   this.activeTab = tab;
  //   this.filterItems();
  // }

  private filterItems() {
    this.filteredItems = this.allItems.filter(item => item.eventType === this.activeTab);
    // console.log("filteredItems", this.filteredItems);
    
  }

  galleryslider = {
    slidesToShow: 3,
    slidesToScroll: 2,
    autoplay: true,
    pauseOnHover: true,
    speed: 600,
    dots: true,
    infinite: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  showToast(message: string, type: string = 'primary') {
    this.toastMessage = message;
    this.toastType = type;

    const toastEl = document.getElementById('liveToast');
    if (toastEl) {
      const toast = new bootstrap.Toast(toastEl, { delay: 3000 });
      toast.show();
    }
  }
}
